import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface ShippingSettings {
  threshold: number;
  cost: number;
}

const DEFAULT: ShippingSettings = { threshold: 150, cost: 12 };

let cached: ShippingSettings | null = null;
let fetching: Promise<ShippingSettings> | null = null;

const fetchSettings = (): Promise<ShippingSettings> => {
  if (cached) return Promise.resolve(cached);
  if (fetching) return fetching;

  fetching = (async () => {
    const { data, error } = await supabase
      .from("site_settings")
      .select("value")
      .eq("key", "shipping_settings")
      .maybeSingle();

    if (error || !data?.value) {
      cached = DEFAULT;
    } else {
      const v = data.value as { threshold?: number; cost?: number };
      cached = {
        threshold: v.threshold ?? DEFAULT.threshold,
        cost: v.cost ?? DEFAULT.cost,
      };
    }
    fetching = null;
    return cached!;
  })();

  return fetching;
};

export const useShippingSettings = () => {
  const [settings, setSettings] = useState<ShippingSettings>(cached ?? DEFAULT);

  useEffect(() => {
    fetchSettings().then(setSettings);
  }, []);

  return settings;
};
